{ SESSION, StorageProxy } = require('app/common/lib/storage')
module.exports = new StorageProxy(SESSION)
